(function () {
	window.addEventListener('DOMContentLoaded', () => {
		const viewAllButtons = document.querySelectorAll('.js-news-lists__view-all-btn');
    
    Array.prototype.forEach.call(viewAllButtons, function(button) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        var blogs = document.querySelectorAll('.js-news-lists-items');

        button.closest('.news-lists__view-all').style.display = 'none';
        Array.prototype.forEach.call(blogs, function(product) {
          product.classList.remove('news-lists__items--hidden');
        });
      });
    });
	})
})();

